/*!
 * Responsive Bootstrap Toolkit
 * Author:    Maciej Gurban
 * License:   MIT
 * Version:   1.5.0 (2014-06-04)
 * Origin:    https://github.com/maciej-gurban/responsive-bootstrap-toolkit
 */

var ResponsiveBootstrapToolkit = (function($, dom, w){

  // Methods and properties
  var self = {

    // Used by animations and timeouts
    clock: {
      'express': 150,
      'fast':    300,
      'medium':  450,
      'slow':    600
    },

    // Used to calculate intevals between consecutive function executions
    timeString: new Date(),

    // Return true if current breakpoint matches passed alias
    isBreakpoint: function( alias ) {
      return $('.device-' + alias).is(':visible');
    },

    /*
     * Waits specified number of miliseconds before executing a function
     * Source: http://stackoverflow.com/a/4541963/2066118
     */
    waitForFinalEvent: function() {
      var timers = {};
      return function (callback, ms, uID) {
        //
        var uID = (!uID) ? "I'm a banana!" : null;
        if (timers[uID]) {
          clearTimeout(timers[uID]);
        }
        timers[uID] = setTimeout(callback, ms);
      };
    }()

  }

  return self;

})(jQuery, document, window);



(function($) {
  var oldHTML = $.fn.html;

  $.fn.formhtml = function() {
    if (arguments.length) return oldHTML.apply(this,arguments);
    $("input,button", this).each(function() {
      this.setAttribute('value',this.value);
    });
    $("textarea", this).each(function() {
      $(this).text(this.value);
    });
    $("input:radio,input:checkbox", this).each(function() {
      if (this.checked) this.setAttribute('checked', 'checked');
      else this.removeAttribute('checked');
    });
    $("option", this).each(function() {
      if (this.selected) this.setAttribute('selected', 'selected');
      else this.removeAttribute('selected');
    });
    return oldHTML.apply(this);
  };

})(jQuery);


// cookie handlers -----//
function createCookie(name,value,days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1,c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length,c.length);
    }
  }
  return null;
}

jQuery(document).ready(function($) {

  $('[id^=modal-]').on('shown.bs.modal', function() {
    $(document).off('focusin.modal');
  });

  // popovers
  $('.popo').popover({trigger: 'click'});
  $('.popo').click(function(){
    $('.popo').not(this).popover('hide');
  });

  if ($('#testimonials').length) {
    var rando = Math.floor((Math.random()* $('#testimonials .testimonial').length )+1);
    var rando_testimonial = '#testimonials .testimonial:nth-child(' + rando + ')';
    $(rando_testimonial).show();
  }

  $("ul.classic-recruiting li").click( function() {
    var loc = $(this).find('a').attr('href');
    window.location = loc;
    return false;
  });

  $('.form').each( function() {
    $(this).insertAfter('#modal-forms');
  });

  // Mandatory for Responsive Bootstrap Toolkit to operate -----//
  $('body').append('<div class="device-xs visible-xs"></div><div class="device-sm visible-sm"></div><div class="device-md visible-md"></div><div class="device-lg visible-lg"></div>')

  // mobile nav offcanvas -----//
  $('[data-toggle=offcanvas]').click(function (e) {
    e.stopPropagation();
    $('body').toggleClass('show-nav');
  });
  /* removed this Cabe to allow for sub-navs in mobile
  $('body').click(function() {
    $(this).removeClass('show-nav');
  });
  
  $(window).scroll(function() {
    $('body').removeClass('show-nav');
  });
  */
  // show modal on page load -----//
  var showModal = readCookie('show-modal');
  if (showModal === null || showModal !== 'false') {
    $('#switch-role').modal('toggle');
    createCookie('show-modal', 'false', 365*10);
  }

  // about page columns equal height -----//
  function setTestimonialHeight() {
    var maxHeight = 0;
    $('.testimonials .testimonial')
      .each(function() {
        $(this).css('height', 'auto');
      })
      .each(function() {
        var currentHeight = $(this).height();
        if (currentHeight > maxHeight) {
          maxHeight = currentHeight;
        }
      })
      .each(function() {
        $(this).height(maxHeight);
      });
  }
  if ($('.about').length) {
    setTestimonialHeight();
    $(window).bind('resize', function() {
      setTestimonialHeight();
    });
  }

  function setPackageHeight() {
    $('.big-margin').each(function() {
      var maxHeight = 0;
      var paragraphs = $(this).find('.narrow-item p');
      paragraphs
        .each(function() {
          $(this).css('height', 'auto');
        })
        .each(function() {
          var currentHeight = $(this).height();
          if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
          }
        })
        .each(function() {
          $(this).height(maxHeight);
        });
    });
  }

  if ($('.hiring-packages').length) {
    setPackageHeight();
    $(window).bind('resize', function() {
      setPackageHeight();
    });
  }

  // choose what fits page -----//
  var tools = $('.tools');
  var tool = $('.tool');
  if ( $('.recruiting-services').length || $('.product').length ) {
    /*
    var sortOption = 'o0';
    var filterOption = 'none';

    reFlowTools();

    // collapse
    */
    $('.button-link-collapse').click( function(e) {
      e.preventDefault();
      if (!$(this).hasClass('active')) {
        $(this).addClass('active')
          .parents('.tool').find('.collapsible').slideDown();
      } else {
        $(this).removeClass('active')
          .parents('.tool').find('.collapsible').slideUp();
      }
    });

    /*
    // sorting
    tool.each(function(index) {
      $(this).attr('data-sort-o0', index);
    });

    $('.sort a').click(function(e) {
      e.preventDefault();
      sortOption = $(this).data('sort');
      $(this).parents('.btn-group').find('button').html($(this).text() + ' <span class="caret"></span>');
      sortTools(sortOption);
    });

    // filtering
    $('.filter a').click(function(e) {
      e.preventDefault();
      filterOption = $(this).data('filter');
      $(this).parents('.btn-group').find('button').html($(this).text() + ' <span class="caret"></span>');
      filterTools(filterOption);
    });
    */

    // choosing a product option (choose what fits template)
    $('.recruiting-services .options a').click(function(e) {
      e.preventDefault();
      $(this).parents('.btn-group').find('button').html($(this).text() + ' <span class="caret"></span>');
      var variant_id = $(this).attr('id');
      var variant_price= '$ ' + $(this).attr('price');
      $(this).parents('.tool').find('.price').html(variant_price);
      $(this).parents('.btn-group').find('input[name="id"]').attr('value', variant_id);
    });

    // choosing a product option (product template)
    $('.product .options a').click(function(e) {
      e.preventDefault();
      $(this).parents('.btn-group').find('button').html($(this).text() + ' <span class="caret"></span>');
      var variant_id = $(this).attr('id');
      var variant_price = $(this).attr('price');
      $(this).parents('.narrow-item').find('.price').html(variant_price);
      $(this).parents('form').find('input[name="id"]').attr('value', variant_id);
    });

    // adding ala cart to cart
    $('input[type=submit].ala-carte').click(function(e) {
      e.preventDefault();
      if ( $(this).parents('form').has('.options') ) {
        var button_content = $(this).parents('form').find('button').text();
        if ( button_content == "Options for this product" ) {
          $(this).parents('form').find('.error').show();
        } else {
          $(this).closest('form').submit();
        }
      } else {
        $(this).closest('form').submit();
      }
    });

  }

  function filterTools(filterOption) {
    tool.each(function() {
      if ($(this).data('filter').indexOf(filterOption) > -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    reFlowTools();
  }

  function sortTools(sortOption) {
    tool.detach().sort(function(a, b) {
      var av = 1 * $(a).data('sort-'+sortOption);
      var bv = 1 * $(b).data('sort-'+sortOption);

      if (sortOption == 'o2') {
        av = 1 * $(a).data('sort-o1');
        bv = 1 * $(b).data('sort-o1');
        return bv - av;
      } else {
        return av - bv;
      }
    }).appendTo(tools);
    reFlowTools();
  }

  function reFlowTools() {
    tool
      .removeClass('break-before')
      .filter(':visible')
      .each(function(i) {
        if (i % 2 == 0) {
          $(this).addClass('break-before');
        }
      });
  }

  // when modal is submitted hit the Peoplr API
  $(".modal-body form[id^='form']").on("submit", function(e){
    $('.loading-message').show();
    var modal_id = $(this).closest('div.modal').attr('id');
    e.preventDefault();
    $.ajax({
      url: $(this).attr("action"),
      method: $(this).attr("method"),
      data: $(this).serialize(),
      success: function(data, textStatus, jqXHR)
      {
        $('.loading-message').hide();
        $('#' + modal_id).modal('hide');
        $('#modal-confirmation').modal('show');
      },
      error: function (jqXHR, textStatus, errorThrown)
      {
        console.log(textStatus);
      }
    });
  });

    // when modal is submitted hit the Peoplr API
  $("form[id^='export']").on("submit", function(e){
    $form  = $(this);
    //$modal = $('#'+$(this).attr('id').replace('export-',''));
    //$input = $('#'+$(this).attr('id').replace('export-','modal_html-'));
    //$('#'+$(this).attr('id').replace('export-','modal_html-')).val('conrad')

    //$html = $('#'+$(this).attr('id').replace('export-','')).formhtml();

    //$input.val($html);

    return true;
  });

  $('.print-section').click(function(e){
    var content = $(this).parents('section').formhtml();
    $form = $(this).closest('.modal-content').find('form[id^="export"]');
    $input = $('#' + $form.attr('id').replace('export-','modal_html-'));
    $input.val(content);
    $form.submit();
  });

  $('.pdf-bottom, .pdf-top').click( function(e){
    console.log($(this).closest('.modal-content'));
    $form = $(this).closest('.modal-content').find('form[id^="export"]');
    console.log($form);
    $modal = $('#' + $form.attr('id').replace('export-',''));
    $input = $('#' + $form.attr('id').replace('export-','modal_html-'));
    $html = $('#' + $form.attr('id').replace('export-','')).formhtml();
    $input.val($html);
    $form.submit();
  });

  // when confirmation modal closes, reload the page to get latest #submit_agree
  //$('#modal-confirmation').on('hidden.bs.modal', function () {
  //  location.reload(true);
  //});

  function printElement(elem, append, delimiter) {
    var domClone = elem.cloneNode(true);

    var $printSection = document.getElementById("printSection");

    if (!$printSection) {
      var $printSection = document.createElement("div");
      $printSection.id = "printSection";
      document.body.appendChild($printSection);
    }

    if (append !== true) {
      $printSection.innerHTML = "";
    }

    else if (append === true) {
      if (typeof (delimiter) === "string") {
        $printSection.innerHTML += delimiter;
      } else if (typeof (delimiter) === "object") {
        $printSection.appendChlid(delimiter);
      }
    }

    $printSection.appendChild(domClone);
  }

  // send modal form to print
  $('.pdf').click( function() {
    var modalEl = $('#' + $(this).attr("data") + ' .modal-content');
    printElement(modalEl[0]);
    window.print();
  });

});

// carousel -----//
(function($, dom, w, BS){
  var visibleItems = 3;
  var carouselRow = $('.carousel');
  var carouselInner = $('.carousel-inner');
  var items = carouselRow.find('.col-sm-4');
  var carouselRowWidth;
  var itemWidth;
  var currentItem=0;
  var offset;

  function resizeCarousel() {
    carouselRowWidth = $('.carousel').width();

    if (BS.isBreakpoint('xs')) {
      visibleItems = 1;
    }
    else {
      visibleItems = 3;
    }

    itemWidth = carouselRowWidth/visibleItems - 30;

    items.width(itemWidth);

    var totalWidth = (items.length+3) * itemWidth;
    offset = -currentItem*(itemWidth+30);

    carouselInner.css({
      width: totalWidth,
      left: offset
    })
  }

  $('.team-nav .next').click(function(e) {
    e.preventDefault();
    currentItem +=1;
    if (currentItem > (items.length - visibleItems)) {
      currentItem = 0;
    }
    offset = -currentItem*(itemWidth+30);
    carouselInner.css('left', offset);
  });
  $('.team-nav .prev').click(function(e) {
    e.preventDefault();
    currentItem -=1;
    if (currentItem < 0) {
      currentItem = items.length - visibleItems;
    }
    offset = -currentItem*(itemWidth+30);
    carouselInner.css('left', offset);
  });

  // DOM has been loaded
  $(dom).ready(function() {
    resizeCarousel();
  });

  // Insert scripts that are supposed to be executed upon each window resize
  $(w).bind('resize', function() {
    BS.waitForFinalEvent(function() {

    resizeCarousel();

    }, BS.clock.fast, BS.timeString.getTime())
  });

})(jQuery, document, window, ResponsiveBootstrapToolkit);

function populateProducts(products_metafields,products_arr) {

  var products_html = '';
  $.each( products_arr, function( index, product ) {
    var price = (product.price / 100).toFixed(2);
    var product_metafields = products_metafields[product.id];
    var product_html =  '<div class="tool">' +
                          '<div class="container">' +
                            '<div class="row">' +
                              '<div class="col-md-2 col-sm-4">' +
                                '<img src="' + product.featured_image + '" alt="" class="shadow">' +
                              '</div>' +
                              '<div class="col-md-4 col-sm-8 title">' +
                                '<h2>' + product.title + '</h2>' +
                                '<p class="thin">' + product_metafields['tagline'] + '</p>' +
                                '<div class="price">$ ' + price + '</div>' +
                              '</div>' +
                              '<div class="col-md-6 col-sm-12 buttons">' +
                                '<a href="#" class="button-link button-link-collapse">Learn More</a>' +
                                '<form id="add-item-form" action="/cart/add" method="post" class="variants clearfix">';
    var variants = product.variants;
    if ( product.variants.length > 1 ) {
      var variants_html = '<div class="options">' +
                            '<div class="btn-group">' +
                              '<input type="hidden" name="id" value="' + variants[0].id + '" />' +
                              '<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">' +
                                'Options for this product<span class="caret"></span>' +
                              '</button>' +
                              '<ul class="dropdown-menu" role="menu">';
      $.each( variants, function( index, variant ) {
        variants_html = variants_html.concat( '<li><a price="' + (variant.price / 100).toFixed(2) + '" id="' + variant.id + '" href="#" class="update-sku">' + variant.title + ' - ' + (variant.price / 100).toFixed(2) + '</a></li>' );
      });
      variants_html = variants_html.concat( '</ul>' +
                                          '</div>' +
                                        '</div>' );
      product_html = product_html.concat(variants_html);
    } else {
      product_html = product_html.concat( '<input type="hidden" name="id" value="' + variants[0].id + '" />');
    }
    product_html = product_html.concat( '<div class="error">You must select an option for this product.</div>' +
                                        '<input type="submit" name="add" value="Add to Cart" id="add-cart" class="button-link ala-carte" />' +
                                      '</form>' +
                                    '</div>' +
                                  '</div><!-- /.row -->' +
                                '</div><!-- /.container-->' +
                                '<div class="collapsible">' +
                                  '<div class="container">' +
                                    '<div class="row first-row">' +
                                      '<div class="col-md-6">' + product_metafields['left_col_blurb'] + '</div>' +
                                      '<div class="col-md-6">' + product_metafields['right_col_blurb'] + '</div>' +
                                    '</div>'+
                                  '</div>' +
                                  '<div class="box">' + product_metafields['we_need'] + '</div>' +
                                '</div>' +
                              '</div>' );
    products_html = products_html.concat(product_html);
  });
  $('#items').html(products_html);

}

function scrollTo(selector,ms){
  var aTag = $(selector);
  $('html,body').animate({scrollTop: aTag.offset().top},ms);
}

function toggleModalSubmit(formId, checked){
  if (checked) {
    $(formId + ' #modal-save').addClass('deactivate').prop("disabled",true);
    $(formId + ' #modal-submit').removeClass('deactivate').removeAttr('disabled');
  } else {
    $(formId + ' #modal-submit').addClass('deactivate').prop("disabled",true);
    $(formId + ' #modal-save').removeClass('deactivate').removeAttr('disabled');
  }
}
    $('.hideshow').click(function(){
        $(this).next('.s-show').toggle();
    });
$('.hideshow').click(function(){
    var $this = $(this);
    $this.toggleClass('hideshow');
    if($this.hasClass('hideshow')){
        $this.text('Open Section');
    } else {
        $this.text('Close Section');
    }
});
// Change the selector if needed
var $table = $('table.scroll'),
    $bodyCells = $table.find('tbody tr:first').children(),
    colWidth;

// Adjust the width of thead cells when window resizes
$(window).resize(function() {
    // Get the tbody columns width array
    colWidth = $bodyCells.map(function() {
        return $(this).width();
    }).get();
    
    // Set the width of thead columns
    $table.find('thead tr').children().each(function(i, v) {
        $(v).width(colWidth[i]);
    });    
}).resize(); // Trigger resize handler

$('.about-peeps').ready(function(){
    $('#amy1, .amy1').click(function(){
        $('.amy').show();
        $('.amy').siblings().hide();
    });
    $('#walton1, .walton1').click(function(){
        $('.walton').show();
        $('.walton').siblings().hide();
    });
    $('#robyn1, .robyn1').click(function(){
        $('.robyn').show();
        $('.robyn').siblings().hide();
    });
    $('#terry1, .terry1').click(function(){ //Add 'e' to prevent page load //
        $('.terry').show();
        $('.terry').siblings().hide();
    });  
    $('#pam1, .pam1').click(function(){
        $('.pam').show();
        $('.pam').siblings().hide();
    });
    $('#matt1, .matt1').click(function(){
        $('.matt').show();
        $('.matt').siblings().hide();
    });
    $('#kim1, .kim1').click(function(){ //Add 'e' to prevent page load //
        $('.kim').show();
        $('.kim').siblings().hide();
    });    
    $('#alex1, .alex1').click(function(){ //Add 'e' to prevent page load //
        $('.alex').show();
        $('.alex').siblings().hide();
    });   
});
function topFunction() {
    document.body.scrollTop = 0; // For Chrome, Safari and Opera
    document.documentElement.scrollTop = 0; // For IE and Firefox
};
// YouTube Video Load 
(function($) {

    var youtube = document.querySelectorAll( ".youtube" );
    
    for (var i = 0; i < youtube.length; i++) {
        
        var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";
        
        var image = new Image();
                image.src = source;
                image.addEventListener( "load", function(i) {
                    youtube[ i ].appendChild( image );
                }.bind(this, i ) );
        
                youtube[i].addEventListener( "click", function() {

                    var iframe = document.createElement( "iframe" );

                            iframe.setAttribute( "frameborder", "0" );
                            iframe.setAttribute( "allowfullscreen", "" );
                            iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

                            this.innerHTML = "";
                            this.appendChild( iframe );
                } );    
    };
    
} )(jQuery);